import React,{useState} from 'react'

import {Formik} from "formik"
import {useHistory } from 'react-router-dom'


import {useMutation,gql}  from "@apollo/client"

const NUEVO_USUARIO = gql `
   mutation Signup($input: NuevoUsuario) {
  signup(input: $input) {
    userErrors {
      message
    }
    user {
      apellido
      email
      name
      password
    }
  }
}`

const Register = () => {
  const history = useHistory()
  const [mensaje, guardarMensaje] = useState(null)

  const  [Signup] = useMutation(NUEVO_USUARIO)

  const mostrarMensaje = ( ) => {
    return(
        <div className=" px-3 w-full text-gray-200 py-5 font-bold text-2xl max-w-sm text-center mx-auto">
            <p>{mensaje}</p>
        </div>
    )    
}
  return (

    <Formik
    initialValues={{ 
        name:"",
        apellido:"",
        email:"",
        password:"",
         }}
   
    onSubmit ={ async (values) => {
        
        const {name,apellido,email,password} = values

        try {
            const {data} = await Signup({
                variables : {
                    input: {
                        name,
                        apellido,
                        email,
                        password
                    }
                }
            })
            
            guardarMensaje(`Se creo correctamente el Usuario: ${data.signup.user.name}`);
            setTimeout(() => {
                guardarMensaje(null)
                history.push("/login")
                history.go()
            },500)
            //Usuario creado correctamente 
        }catch(error){
            guardarMensaje(error.message)

           setTimeout(() => {
              guardarMensaje(null) 
           }, 5000);
        }
    }}
    

   
  >
     {props => (

      <div className='h-screen bg-gray-800'>
        {mensaje && mostrarMensaje()}
        <h1 className="text-center pt-2 text-2xl text-white font-light">Crear Nueva Cuenta</h1>

        <div className="flex justify-center mt-5">
        <div className="w-full max-w-sm">
            <form
                className="bg-white rounded shadow-md px-8 pt-6 pb-8 mb-4"
                onSubmit={props.handleSubmit}
            >

                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
                        Nombre
                    </label>

                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="name"
                        type="text"
                        placeholder="Nombre Usuario"
                        value={props.values.name}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                    />
                </div>

                { props.touched.name && props.errors.name ? (
                    <div className="my-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-4" >
                        <p className="font-bold">Error</p>
                        <p>{props.errors.name}</p>
                    </div>
                ) : null  }

                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="apellido">
                        Apellido
                    </label>

                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="apellido"
                        type="text"
                        placeholder="Apellido Usuario"
                        value={props.values.apellido}
                        onChange={props.handleChange}
                    />
                </div>

                { props.touched.apellido && props.errors.apellido ? (
                    <div className="my-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-4" >
                        <p className="font-bold">Error</p>
                        <p>{props.errors.apellido}</p>
                    </div>
                ) : null  }

                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                        Email
                    </label>

                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="email"
                        type="email"
                        placeholder="Email Usuario"
                        value={props.values.email}
                        onChange={props.handleChange}
                    />
                </div>

                { props.touched.email && props.errors.email ? (
                    <div className="my-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-4" >
                        <p className="font-bold">Error</p>
                        <p>{props.errors.email}</p>
                    </div>
                ) : null  }

                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                        Password
                    </label>

                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="password"
                        type="password"
                        placeholder="Password Usuario"
                        value={props.values.password}
                        onChange={props.handleChange}
                    />
                </div>

                { props.touched.password && props.errors.password ? (
                    <div className="my-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-4" >
                        <p className="font-bold">Error</p>
                        <p>{props.errors.password}</p>
                    </div>
                ) : null  }

                <input
                    type="submit"
                    className="bg-gray-800 w-full mt-5 p-2 text-white uppercas hover:cursor-pointer hover:bg-gray-900"
                    value="Crear Cuenta"
                />
                <div className='flex'>
                    <div className='w-7/12'>  </div>
                    <a href="/login"><a className='text-sm mt-4 hover:underline '>Ya tengo una cuenta</a></a>
                </div>

            </form>
        </div>
    </div>

      </div>
   
   


)}
  </Formik>
  )
}

export default Register